var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHibernate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: #f4f4f4;\n      }\n\n      .cls-3 {\n        fill: #bdaf7a;\n      }\n\n      .cls-4 {\n        fill: #5a676d;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -1.9,
    y: -2.1,
    width: 87.8,
    height: 99.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4803.7-375.5h2500v2500h-2500V-375.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M49.9,61.2l-.3.9,15.5,26.2.9.6,16.2-28-16.2-28.1-16.1,28.3h0ZM17.4,5L1.6,33l16.4,28.3,15.7-28.3v-1.1L18.1,5.7l-.7-.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.4,5l16.3,28h32.3L49.6,5H17.4ZM18,61.2l15.9,27.7h32l-16.1-27.7h-31.9,0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHibernate);
export default __webpack_public_path__ + "static/media/Hibernate.ced4080c7a8de56e48610247812431de.svg";
export { ForwardRef as ReactComponent };